export default (collection = []) => {
  return collection.map((resource) => {
    const { attributes, ...rest } = resource
    return {
      ...attributes,
      ...rest,
    }
  })
}
